import { call, put } from 'redux-saga/effects';
import FotaCarActions from '../redux/FotaCarRedux';
import MessagesActions from '../redux/MessagesRedux';

export function* getFotaCar(api, action) {
  const response = yield call(api.getFotaCar, action.id);

  if (response.ok) {
    yield put(FotaCarActions.fotaCarSuccess(response.data));
  } else {
    yield put(FotaCarActions.fotaCarFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}

export function* addFotaCar(api, action) {
  const response = yield call(api.addFotaCar, action.data);

  if (response.ok) {
    yield put(FotaCarActions.fotaCarSuccess(response.data));
    yield put(MessagesActions.messagesShow({ type: 'success', code: 'fotaCarAdd', title: 'Запись успешно создана' }));
  } else {
    yield put(FotaCarActions.fotaCarFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}

export function* updateFotaCar(api, action) {
  const response = yield call(api.editFotaCar, action.data);

  if (response.ok) {
    yield put(FotaCarActions.fotaCarSuccess(response.data));
    yield put(MessagesActions.messagesShow({ type: 'success', code: 'fotaCarUpdate', title: 'Запись успешно обновлена' }));
  } else {
    yield put(FotaCarActions.fotaCarFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}

export function* deleteFotaCar(api, action) {
  const response = yield call(api.deleteFotaCar, action.id);

  if (response.ok) {
    yield put(FotaCarActions.fotaCarSuccess(null));
    yield put(MessagesActions.messagesShow({ type: 'success', code: 'fotaCarDelete', title: 'Запись успешно удалена' }));
  } else {
    yield put(FotaCarActions.fotaCarFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}